//#region src/default_mod_behavior.ts
var DefaultModBehavior = /* @__PURE__ */ function(DefaultModBehavior) {
	DefaultModBehavior["UseSystemDefault"] = "use-system-default";
	DefaultModBehavior["Send"] = "send";
	DefaultModBehavior["DoNotSend"] = "do-not-send";
	return DefaultModBehavior;
}(DefaultModBehavior || {});
//#endregion
export { DefaultModBehavior };

//# sourceMappingURL=default_mod_behavior.js.map